import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'El checklist de valoración y la tabla de signos de alarma me cambiaron completamente la forma de estudiar. Antes memorizaba datos. Ahora sé qué mirar primero y por qué.',
    initial: 'C',
    name: 'Camila R.',
    location: 'Córdoba',
    role: 'Estudiante de 4° año'
  }, {
    text: 'El Tomo 6 y los casos clínicos me ayudaron a conectar la teoría con situaciones reales del hospital. Lo recomiendo a cualquiera que esté entrando al internado.',
    initial: 'M',
    name: 'Martín L.',
    location: 'Buenos Aires',
    role: 'Enfermero junior'
  }, {
    text: 'Las plantillas del Bono 3 me salvan en cada práctica. Registro mejor, más ordenado y con más seguridad. Mi tutor lo notó enseguida.',
    initial: 'S',
    name: 'Sofía C.',
    location: 'Rosario',
    role: 'Estudiante en prácticas'
  }, {
    text: 'La parte de farmacología y cálculos era lo que más me costaba. Con el Tomo 5 y el Bono 4 lo pude ordenar por primera vez.',
    initial: 'P',
    name: 'Paula A.',
    location: 'Mendoza',
    role: 'Estudiante avanzada'
  }, {
    text: 'El plan de 21 días fue clave. Tenía material por todos lados pero no sabía cómo organizarme. Esto me dio una ruta clara.',
    initial: 'L',
    name: 'Lucía M.',
    location: 'La Plata',
    role: 'Estudiante de enfermería'
  }];
  return <section className="py-12 md:py-20 lg:py-24 bg-white" data-id="element-369">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-370">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-12" data-id="element-371">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-4" data-id="element-372">
            Testimonios
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-clinical-deep mb-4 leading-[1.05] uppercase" data-id="element-373">
            Estudiantes que{' '}
            <span className="accent-italic normal-case" data-id="element-374">ya lo tienen</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-375">
          {testimonials.map((testimonial, idx) => {
          const isLast = idx === testimonials.length - 1;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className={`bg-clinical-base rounded-2xl p-5 md:p-7 border border-clinical-line flex flex-col ${isLast ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-376">
                <div className="flex gap-1 mb-4 justify-center md:justify-start" data-id="element-377">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-clinical-accent text-clinical-accent" data-id="element-378" />)}
                </div>

                <p className="text-clinical-ink mb-5 flex-grow text-sm md:text-base leading-relaxed text-center md:text-left" data-id="element-379">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center gap-3 mt-auto pt-4 border-t border-clinical-line justify-center md:justify-start" data-id="element-380">
                  <div className="w-11 h-11 rounded-full bg-clinical-soft text-clinical-deep font-bold text-lg flex items-center justify-center flex-shrink-0" data-id="element-381">
                    {testimonial.initial}
                  </div>
                  <div className="text-left" data-id="element-382">
                    <div className="font-bold text-clinical-deep text-sm" data-id="element-383">
                      {testimonial.name}
                    </div>
                    <div className="text-[11px] text-clinical-ink/60" data-id="element-384">
                      {testimonial.location} · {testimonial.role}
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}